var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'layout-no-bottom-nav': !_vm.isMobile
  }},[_c('TopNav'),_vm._v(" "),_c('div',{class:{
      'layout-no-bottom-nav__container': !_vm.isMobile,
      'layout-no-bottom-nav__container_mobile': _vm.isMobile
    }},[_c('Nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }